import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LanguageService } from '@core/services/language.service';
import { LoadingService } from '@core/services/loading.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-main-categories',
  templateUrl: './main-categories.component.html',
  styleUrls: ['./main-categories.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MainCategoriesComponent implements OnInit {
  public arrCoupons: any[] = [];
 
  constructor( 
    private apisService: ApisService,
    // private loadingService: Loadingscr,
    private router: Router, 
    private loading : LoadingService, 
    private toastr : ToastrService, 
    private modal : NgbModal , 
    private language : LanguageService
  ) {} 

  public currentPage = 1; 
  public itemsPerPage = 10;
  public totalItems = 0;
  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;

 
  public levels: any[] = [];
  public tempData = [];
  public categories : any
  public categoryName : any
  public isEdit :boolean = false
  public categoryId : any
  public lang : any

  @ViewChild(DatatableComponent) table: DatatableComponent;

 

  // ngOnInit(): void {
  //   this.getLevels();

  // }
  ngOnInit(): void {
    this.language.currentLang.subscribe(data => this.lang = data)
    this.getMainCategories();

  }

 getMainCategories(){
      this.loading.show()
  this.apisService.getMainCategories(this.currentPage).subscribe((res: any) => {
    this.loading.hide()
    this.categories = res.data;
    this.totalItems = this.categories.length;
  })
 }

 
 /*----------  Add Category   ----------*/
 addCategory(){
  this.apisService.addCategories({categoryName: this.categoryName}).subscribe((res: any) => {
    this.toastr.success("Category added successfully", "Success");
  })
 }
 

 
 /*----------  delete main category  ----------*/
 deleteCategory(id: number) {
   this.apisService.deleteMainCategories(id).subscribe({
     next: (res) => {
       this.getMainCategories();
       this.toastr.success("Category deleted successfully", "Success");
     },
     error: (err) => {
       console.log('error in fetching', err)
       this.toastr.error("Something went wrong", "Error")
     }
   })
 }

 
 /*----------  Show category details   ----------*/
 categoryDetails(id: any) {
   this.apisService.showMainCategories(id).subscribe({
     next: (res) => {
       console.log(res)
     },
     error: (err) => {
       console.log('error in fetching', err)
       this.toastr.error("Something went wrong", "Error")
     }
   })
 }

 
 /*----------  edit category  ----------*/
 categoryEdit(id: any) {
  console.log(this.categoryName)
  console.log(id)
   this.apisService.editMainCategories(id , this.categoryName).subscribe({
     next: (res) => {
       this.getMainCategories();
       this.toastr.success("Category updated successfully", "Success");
       this.modal.dismissAll();
     },
     error: (err) => {
       console.log('error in fetching', err)
       this.toastr.error("Something went wrong", "Error")
     }
   })
 }

 
 
 

/*=============================================
=            Modal Functions            =
=============================================*/
openModal(content: any, edit?: boolean, row?: any) {
  this.isEdit = !!edit;

  if (this.isEdit && row) {
    this.categoryId = row.id;
    this.categoryName = row.categoryName; // 👈 ADD THIS
  } else {
    this.categoryId = null;
    this.categoryName = '';
  }

  const modalRef = this.modal.open(content, {
    centered: true,
    size: 'md'
  });

  // ❌ REMOVE page reloads (not needed and bad UX)
}

close(){
  this.modal.dismissAll();
}



/*=====  End of Modal Functions  ======*/


  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.arrCoupons = this.tempData.filter((d) =>
      d.code.toLowerCase().includes(val)
    );
    this.table.offset = 0;
  }

  /*----------  Pagination Functions   ----------*/
next(){ 
  this.currentPage++
  this.getMainCategories()
}

prev(){ 
  this.currentPage--
  this.getMainCategories()
}

}
